import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { analysisTargetValues } from '@/entities/settlementstatisticsconverter/lib/analysis-target';
import {
  comparisonDisplayModeValues,
  DEFAULT_COMPARISON_DISPLAY_MODE,
} from '@/entities/settlementstatisticsconverter/lib/comparison-display-mode';
import { SettlementStatisticsConverterDetailAnalysisPage } from '@/pages/settlement-statistics-converter/ui/SettlementStatisticsConverterDetailAnalysisPage';
import { amountUnitValues } from '@/shared/lib/amount/convertAmount';
import { routeValidateQuerySearch } from '@/shared/lib/route';

/** 分析タブのURLクエリパラメータスキーマ */
const analysisSearchSchema = z.object({
  query_store_id: z.string().optional(),
  analysis_target: z.enum(analysisTargetValues).default('expenditure'),
  template_id: z.string().optional(),
  amount_unit: z.enum(amountUnitValues).optional(),
  comparison_mode: z
    .enum(comparisonDisplayModeValues)
    .default(DEFAULT_COMPARISON_DISPLAY_MODE)
    .optional(),
});

/**
 * 決算統計コンバーター結果詳細ルート（分析タブ）
 */
export const Route = createFileRoute(
  '/_protected/settlement-statistics-converter/$resultId/analysis',
)({
  component: () => <SettlementStatisticsConverterDetailAnalysisPage />,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: analysisSearchSchema,
      defaultValues: {},
    }),
});
